import type { ReactNode } from 'react';
import './ButtonContent.css';

/** Keep idle content in layout and accessibility while three dots convey work visually. */
export function ButtonContent({ loading, children, className = '' }: { children: ReactNode; loading: boolean; className?: string }) {
  return <span className={`button-content ${className}`} data-loading={loading}>
    <span className="button-content-label">{children}</span>
    <span className="button-content-dots" aria-hidden="true">
      <span data-loading-dot /><span data-loading-dot /><span data-loading-dot />
    </span>
  </span>;
}
